export const PARTIAL_PAYMENT_TRIGGER = "partial_payment_trigger";
export const CONTINUED_TRANSACTION = "continued_transaction";
/** Fired when a new cart is posted into the iframe — clears dismiss-confirm modal state */
export const RESET_IFRAME_CLOSE_MODAL = "reset-iframe-close-modal";
/** Fired on logout — allows the same cart to re-run iframe autologin */
export const RESET_IFRAME_CART_INIT = "reset-iframe-cart-init";
